import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PrescriptionSchedulingService } from 'src/app/shared/services/API/orchestrator-patient/prescription-scheduling.service';
import { ObservationScheduling } from 'src/app/shared/services/models/bed/observation-scheduling.model';
import { StatusScheduling } from 'src/app/shared/services/models/medical-record/status-scheduling.model';
import { MedicalProcedureStruct } from 'src/app/shared/services/structs/medical-record/medical-procedure.struct';
import { SadtGroupStruct } from 'src/app/shared/services/structs/medical-record/sadt-group.struct';
import { DateTimeStruct } from 'src/app/shared/services/structs/orchestrator-patient/date-time.struct';
import { MedicalRecordLookupService } from 'src/app/shared/services/API/medical-record/lookup.service';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { ProcedureSchedulingModalComponent } from '../procedure-scheduling-modal/procedure-scheduling-modal.component';
import { SadtSchedulingModalComponent } from '../sadt-scheduling-modal/sadt-scheduling-modal.component';
import { StatusSchedulingEnum } from 'src/app/shared/enum/medical-record/status-scheduling.enum';
import { MedicatedSolutionSchedulingModalComponent } from '../medicated-solution-scheduling-modal/medicated-solution-scheduling-modal.component';
import { AllergyModel } from 'src/app/shared/services/models/medical-record/allergy.model';
import { GetListMedicineStruct } from 'src/app/shared/services/structs/pharmacy/get-list-medicine.struct';
import { MedicalProcedureCheckRequest } from 'src/app/shared/services/requests/medical-record/medical-procedure-check.request';
import { PrescriptionSchedulingModalComponent } from '../prescription-scheduling-modal/prescription-scheduling-modal.component';
import { MedicalProcedureModalComponent } from 'src/app/observation/pages/bed-management-details/procedure-list/medical-procedure-modal/medical-procedure-modal.component';
import { CheckRestrictedOverdueMedicationModalComponent } from '../../check-restricted-overdue-medication-modal/check-restricted-overdue-medication-modal.component';
import { UtilService } from 'src/app/shared/services/util.service';
import { UserRoleEnum } from 'src/app/shared/enum/user-role.enum';
import { FrequencyEnum } from 'src/app/shared/enum/medical-record/frequency.enum';
import { LatePendingChecksModalComponent } from '../late-pending-checks-modal/late-pending-checks-modal.component';
import { MedicalProcedureCheckStruct } from 'src/app/shared/services/structs/orchestrator-patient/medical-procedure-check.struct';
import { PrescriptionStatusEnum } from 'src/app/shared/enum/prescription-status.enum';
import { SadtStatusEnum } from 'src/app/shared/enum/sadt-status.enum';
import { PrescriptionObservationOnBed } from 'src/app/shared/services/models/medical-record/prescription-observation-on-bed.model';
import { PrescriptionMedicineStruct } from 'src/app/shared/services/structs/pharmacy/prescription-medicine.struct';
import { PrescriptionSolutionStruct } from 'src/app/shared/services/structs/pharmacy/prescription-solution.struct';
import { PrescriptionMedicineCheckStruct } from 'src/app/shared/services/structs/pharmacy/prescription-medicine-check.struct';
import { PrescriptionModalComponent } from 'src/app/observation/pages/bed-management-details/presciption-list/prescription-modal/prescription-modal.component';
import { PrescriptionSolutionCheckStruct } from 'src/app/shared/services/structs/pharmacy/prescription-solution-check.struct';
import { MedicineTagUtilsService } from 'src/app/shared/services/medicine-tag-utils.service';
import { AdministrationLocationEnum } from 'src/app/shared/enum/pharmacy/administration-location.enum';
import { ReleasePrescriptionModalComponent } from '../../release-prescription-modal/release-prescription-modal.component';
import { PrescriptionSolutionModalComponent } from '../../prescription-solution-modal/prescription-solution-modal.component';
import { LocationModel } from 'src/app/shared/services/models/pharmacy/location.model';
import { LocationService } from 'src/app/shared/services/API/pharmacy/location.service';
import { DilutionUnit } from 'src/app/shared/services/models/pharmacy/dilution-unit.model';
import { Dilution } from 'src/app/shared/services/models/pharmacy/dilution.model';
import { DoseToAdministered } from 'src/app/shared/services/models/pharmacy/dose-to-administered.model';
import { Frequency } from 'src/app/shared/services/models/pharmacy/frequency.model';
import { MeasurementUnit } from 'src/app/shared/services/models/pharmacy/measurement-unit.model';
import { MedicineAdministrationTypeModel } from 'src/app/shared/services/models/pharmacy/medicine-administration-type.model';
import { MedicinePresentationTypeModel } from 'src/app/shared/services/models/pharmacy/medicine-presentation-type.model';
import { SubFrequency } from 'src/app/shared/services/models/pharmacy/sub-frequency.model';
import { TreatmentPeriod } from 'src/app/shared/services/models/pharmacy/treatment-period.model';
import { Usage } from 'src/app/shared/services/models/pharmacy/usage.model';

@Component({
    selector: 'app-prescription-scheduling-table',
    templateUrl: './prescription-scheduling-table.component.html',
    styleUrls: ['./prescription-scheduling-table.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class PrescriptionSchedulingTableComponent implements OnInit {
  constructor(
    public dialog: MatDialog,
    private alertService: AlertService,
    public prescriptionSchedulingService: PrescriptionSchedulingService,
    public medicalRecordLookupService: MedicalRecordLookupService,
    private utilService: UtilService,
    private locationService: LocationService,
    public medicineTagUtilsService: MedicineTagUtilsService,
  ) { }

  @Input() listDateTime: DateTimeStruct[] = [];
  @Input() listPrescriptionMedicine: PrescriptionMedicineStruct[] = [];
  @Input() listPrescriptionSolution: PrescriptionSolutionStruct[] = [];
  @Input() listMedicalProcedureStruct: MedicalProcedureStruct[] = [];
  @Input() listSadtGroup: SadtGroupStruct[] = [];
  @Input() observationScheduling: ObservationScheduling;
  @Input() cycleTime: number;
  @Input() startDateCycle: Date;
  @Input() isChecking: boolean = false;
  //para checagem de medicamentos
  @Input() listPrescriptionMedicineCheckStruct: PrescriptionMedicineCheckStruct[] = [];
  @Input() listPrescriptionSolutionCheckStruct: PrescriptionSolutionCheckStruct[] = [];
  @Input() listCheckedProcedure: MedicalProcedureCheckRequest[];
  @Input() allergiesToSave: AllergyModel[] = [];
  @Input() listMedicine: GetListMedicineStruct;
  @Input() patientName: string;
  @Input() birthDate: Date;
  @Input() idEpisode: number;
  @Input() listPrescriptionObservationOnBed: PrescriptionObservationOnBed[] = [];
  @Input() idSector: number;
  @Input() listMedicinePresentationType: MedicinePresentationTypeModel[] = [];
  @Input() listDilution: Dilution[] = [];
  @Input() listMeasurementUnit: MeasurementUnit[] = [];
  @Input() listMedicineAdministrationType: MedicineAdministrationTypeModel[] = [];
  @Input() listDoseToAdministered: DoseToAdministered[] = [];
  @Input() listDilutionUnit: DilutionUnit[] = [];
  @Input() listFrequency: Frequency[] = [];
  @Input() listSubFrequency: SubFrequency[] = [];
  @Input() listTreatmentPeriod: TreatmentPeriod[] = [];
  @Input() listUsage: Usage[] = [];
  
  @Output() attPrescription = new EventEmitter<any>();
  @Output() checkPrescription = new EventEmitter<any>();
  @Output() checkProcedure = new EventEmitter<any>();
  @Output() procedureSigtapSelected: EventEmitter<number> = new EventEmitter<number>();
  @Output() releasePrescription = new EventEmitter<any>();

  public prescriptionStatusEnum: typeof PrescriptionStatusEnum = PrescriptionStatusEnum;
  public statusSchedulingEnum: typeof StatusSchedulingEnum = StatusSchedulingEnum;
  public frequencyEnum: typeof FrequencyEnum = FrequencyEnum;
  public prescricaoSuspenso: PrescriptionStatusEnum = PrescriptionStatusEnum.Suspenso;
  public sadtStatusEnum: typeof SadtStatusEnum = SadtStatusEnum;
  public administrationExterna: number = AdministrationLocationEnum.ExternaCasa;
  public showSubtitle: boolean = false;
  public isLoading: boolean = false;
  public isLoadingRelease: boolean = false;
  public listStatusScheduling: StatusScheduling[] = [];
  public listLocation: LocationModel[];

  ngOnInit(): void {
    this.getStatusScheduling();
    if (this.isChecking)
      this.populateLocationSelect();
  }

  changeShowSubtitle() {
    this.showSubtitle = !this.showSubtitle;
  }

  openPrescriptionSchedulingModal(prescription: PrescriptionMedicineStruct, date: string, hour: number) {
    if (this.isChecking) {
      if (!prescription.listPrescriptionMedicineCheck || prescription.listPrescriptionMedicineCheck.length == 0) {
        if (prescription.prescriptionMedicine.idLookupAdministrationLocation != null && prescription.prescriptionMedicine.idLookupAdministrationLocation === this.administrationExterna) {
          this.alertService.show('Alerta', "Não é possível realizar nenhuma interação, pois a orientação de administração deste item está como Externa/Casa.", AlertType.warning);
          return;
        }
        if (prescription.prescriptionMedicine.idFrequency != this.frequencyEnum.agora) {
          this.alertService.show('Alerta', "Não é possível realizar nenhuma interação, pois este item ainda não foi aprazado. Procure o ENFERMEIRO responsável.", AlertType.warning);
          return;
        }
      }

      let [day, month, year] = date.split('/').map(Number);
      let dateStatus = new Date(year, (month - 1), day);
      let indexPrescriptionCheck = prescription.listPrescriptionMedicineCheck.findIndex(x => {
        let formatDate = new Date(x.prescriptionMedicineCheck.datetimeCheckEstimative);
        return formatDate.getFullYear() == dateStatus.getFullYear()
          && formatDate.getMonth() == dateStatus.getMonth()
          && formatDate.getDate() == dateStatus.getDate()
          && formatDate.getHours() == hour
      });

      if (indexPrescriptionCheck == null || indexPrescriptionCheck == undefined) {
        this.alertService.show('Alerta', "Aprazamento não encontrado", AlertType.warning);
      }

      let medicalPrescriptionCheck = prescription.listPrescriptionMedicineCheck[indexPrescriptionCheck];
      if (prescription.listPrescriptionMedicineCheck.some(prescription => prescription.prescriptionMedicineCheck.idStatusScheduling === StatusSchedulingEnum.Suspenso
        && prescription.prescriptionMedicineCheck.idPrescriptionMedicineCheck !== medicalPrescriptionCheck.prescriptionMedicineCheck.idPrescriptionMedicineCheck
        && prescription.prescriptionMedicineCheck.datetimeCheckFulfilled == null
        && !prescription.isBeforeActualSchedulingCycle)) {
        return this.alertService.show('Erro', "Existe uma checagem suspensa para esta prescrição. Salve a conduta para fazer uma nova checagem.", AlertType.error);
      }
      else if (prescription.listPrescriptionMedicineCheck.some(prescription => prescription.prescriptionMedicineCheck.idStatusScheduling === StatusSchedulingEnum.Concluido
        && prescription.prescriptionMedicineCheck.idPrescriptionMedicineCheck !== medicalPrescriptionCheck.prescriptionMedicineCheck.idPrescriptionMedicineCheck
        && prescription.prescriptionMedicineCheck.datetimeCheckFulfilled == null
        && !prescription.isBeforeActualSchedulingCycle)) {
        return this.alertService.show('Erro', "Existe uma checagem concluida para esta prescrição. Salve a conduta para fazer uma nova checagem.", AlertType.error);
      }

      if ((medicalPrescriptionCheck && medicalPrescriptionCheck.prescriptionMedicineCheck.idStatusScheduling === StatusSchedulingEnum.Aprazado)
        && prescription.prescriptionMedicine.idFrequency != this.frequencyEnum.agora)
        return this.alertService.show('Erro', "Existe uma checagem anterior à ser feita.", AlertType.error);

      if ((medicalPrescriptionCheck && medicalPrescriptionCheck.prescriptionMedicineCheck.idStatusScheduling === StatusSchedulingEnum.Atrasado)
        && prescription.prescriptionMedicine.idFrequency != this.frequencyEnum.agora) {
        let listRole = this.utilService.getRoles();
        let isMaster = this.utilService.getToken().isMaster;
        if (!listRole.some(x => x.idRole === UserRoleEnum.checar_atrasado_com_restrição) && !isMaster)
          return this.alertService.show('Erro!', "Usuário sem permissão para checar prescrição atrasada.", AlertType.error);
        else {
          const dialogRef = this.dialog.open(CheckRestrictedOverdueMedicationModalComponent, {
          });
          dialogRef.afterClosed().subscribe(result => {
            if (result && result.confirm && result.response) {
              this.openCheckPrescriptionModal(prescription, indexPrescriptionCheck, medicalPrescriptionCheck, result.response);
            }
          });
        }
      }
      else
        this.openCheckPrescriptionModal(prescription, indexPrescriptionCheck, medicalPrescriptionCheck);
    }
    else {
      const dialogRef = this.dialog.open(PrescriptionSchedulingModalComponent, {
        data: {
          observationScheduling: this.observationScheduling,
          cycleTime: this.cycleTime,
          startDateCycle: this.startDateCycle,
          prescriptionItem: prescription,
        },
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result && result.prescription) {
          let index = this.listPrescriptionMedicine.findIndex(x => x.prescriptionMedicine.idPrescriptionMedicine == result.prescription.prescriptionMedicine.idPrescriptionMedicine)
          if (index != null) {
            this.listPrescriptionMedicine[index] = result.prescription;
            this.attPrescription.emit({ listPrescriptionMedicine: this.listPrescriptionMedicine });
          }
        }
      });
    }
  }

  openCheckPrescriptionModal(prescription: PrescriptionMedicineStruct, indexPrescriptionCheck: number, selectedPrescriptionCheck: PrescriptionMedicineCheckStruct, verifyPermissionResponse = null) {
    const dialogRef = this.dialog.open(PrescriptionModalComponent, {
      data: {
        prescription: prescription,
        selectedPrescriptionCheck: selectedPrescriptionCheck,
        patientName: this.patientName,
        birthDate: this.birthDate,
        actions: true,
        idEpisode: this.idEpisode,
        isMedicatedSolution: false,
        allergiesToSave: this.allergiesToSave,
        listMedicine: this.listMedicine,
        useScheduling: true,
        verifyPermissionResponse: verifyPermissionResponse,
        listPrescriptionObservationOnBed: this.listPrescriptionObservationOnBed,
        listPresentation: this.listMedicinePresentationType,
        listDilution: this.listDilution,
        listMeasurementUnit: this.listMeasurementUnit,
        listAdministrationType: this.listMedicineAdministrationType,
        listDoseToAdministered: this.listDoseToAdministered,
        listDilutionUnit: this.listDilutionUnit,
        listFrequency: this.listFrequency,
        listSubFrequency: this.listSubFrequency,
        listTreatmentPeriod: this.listTreatmentPeriod,
        listUsage: this.listUsage,
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.checkPrescription.emit(true);
        result.prescriptionMedicineCheckStruct.prescriptionMedicineCheck.idPrescriptionMedicine = prescription.prescriptionMedicine.idPrescriptionMedicine;
        let indexCheck = this.listPrescriptionMedicineCheckStruct.findIndex(l => l.prescriptionMedicineCheck.idPrescriptionMedicine == result.prescriptionMedicineCheckStruct.prescriptionMedicineCheck.idPrescriptionMedicine);
        if (indexCheck >= 0)
          this.listPrescriptionMedicineCheckStruct[indexCheck] = result.prescriptionMedicineCheckStruct;
        else
          this.listPrescriptionMedicineCheckStruct.push(result.prescriptionMedicineCheckStruct);

        let indexPrescription = this.listPrescriptionMedicine.findIndex(x => x.prescriptionMedicine.idPrescriptionMedicine == prescription.prescriptionMedicine.idPrescriptionMedicine)
        if (indexPrescription >= 0) {
          if (!selectedPrescriptionCheck)
            selectedPrescriptionCheck = new PrescriptionMedicineCheckStruct();

          selectedPrescriptionCheck.prescriptionMedicineCheck.idStatusScheduling = result.prescriptionMedicineCheckStruct.prescriptionMedicineCheck.idStatusScheduling;
          selectedPrescriptionCheck.prescriptionMedicineCheck.reasonSuspension = result.prescriptionMedicineCheckStruct.prescriptionMedicineCheck.reasonSuspension;
          prescription.listPrescriptionMedicineCheck[indexPrescriptionCheck] = selectedPrescriptionCheck;
          this.listPrescriptionMedicine[indexPrescription] = prescription;
        }
      }
    });
  }

  openMedicatedSolutionSchedulingModal(prescription: PrescriptionSolutionStruct, date: string, hour: number) {
    if (this.isChecking) {

      if (!prescription.listSolutionCheck || prescription.listSolutionCheck.length == 0) {
        if (prescription?.prescriptionSolution?.idLookupAdministrationLocation != null && prescription.prescriptionSolution.idLookupAdministrationLocation === this.administrationExterna) {
          this.alertService.show('Alerta', "Não é possível realizar nenhuma interação, pois a orientação de administração deste item está como Externa/Casa.", AlertType.warning);
          return;
        }
        if (prescription?.prescriptionSolution?.idFrequency != this.frequencyEnum.agora) {
          this.alertService.show('Alerta', "Não é possível realizar nenhuma interação, pois este item ainda não foi aprazado. Procure o ENFERMEIRO responsável.", AlertType.warning);
          return;
        }
      }

      let [day, month, year] = date.split('/').map(Number);
      let dateStatus = new Date(year, (month - 1), day);
      let indexPrescriptionCheck = prescription.listSolutionCheck.findIndex(x => {
        let formatDate = new Date(x.prescriptionSolutionCheck.datetimeCheckEstimative);
        return formatDate.getFullYear() == dateStatus.getFullYear()
          && formatDate.getMonth() == dateStatus.getMonth()
          && formatDate.getDate() == dateStatus.getDate()
          && formatDate.getHours() == hour
      });

      if (indexPrescriptionCheck == null || indexPrescriptionCheck == undefined) {
        this.alertService.show('Alerta', "Aprazamento não encontrado", AlertType.warning);
      }

      let medicalPrescriptionCheck = prescription.listSolutionCheck[indexPrescriptionCheck];

      if (prescription.listSolutionCheck.some(prescription => prescription.prescriptionSolutionCheck.idStatusScheduling === StatusSchedulingEnum.Suspenso
        && prescription.prescriptionSolutionCheck.idPrescriptionSolutionCheck !== medicalPrescriptionCheck.prescriptionSolutionCheck.idPrescriptionSolutionCheck
        && prescription.prescriptionSolutionCheck.datetimeCheckFulfilled == null
        && !prescription.isBeforeActualSchedulingCycle)) {
        return this.alertService.show('Erro', "Existe uma checagem suspensa para esta prescrição. Salve a conduta para fazer uma nova checagem.", AlertType.error);
      }
      else if (prescription.listSolutionCheck.some(prescription => prescription.prescriptionSolutionCheck.idStatusScheduling === StatusSchedulingEnum.Concluido
        && prescription.prescriptionSolutionCheck.idPrescriptionSolutionCheck !== medicalPrescriptionCheck.prescriptionSolutionCheck.idPrescriptionSolutionCheck
        && prescription.prescriptionSolutionCheck.datetimeCheckFulfilled == null
        && !prescription.isBeforeActualSchedulingCycle)) {
        return this.alertService.show('Erro', "Existe uma checagem concluida para esta prescrição. Salve a conduta para fazer uma nova checagem.", AlertType.error);
      }

      if ((medicalPrescriptionCheck && medicalPrescriptionCheck.prescriptionSolutionCheck.idStatusScheduling === StatusSchedulingEnum.Aprazado)
        && prescription.prescriptionSolution.idFrequency != this.frequencyEnum.agora)
        return this.alertService.show('Erro', "Existe uma checagem anterior à ser feita.", AlertType.error);

      if ((medicalPrescriptionCheck && medicalPrescriptionCheck.prescriptionSolutionCheck.idStatusScheduling === StatusSchedulingEnum.Atrasado)
        && prescription.prescriptionSolution.idFrequency != this.frequencyEnum.agora) {
        let listRole = this.utilService.getRoles();
        let isMaster = this.utilService.getToken().isMaster;
        if (!listRole.some(x => x.idRole === UserRoleEnum.checar_atrasado_com_restrição) && !isMaster)
          return this.alertService.show('Erro!', "Usuário sem permissão para checar prescrição atrasada.", AlertType.error);
        else {
          const dialogRef = this.dialog.open(CheckRestrictedOverdueMedicationModalComponent, {
          });
          dialogRef.afterClosed().subscribe(result => {
            if (result && result.confirm && result.response) {
              this.openCheckPrescriptionSolutionModal(prescription, indexPrescriptionCheck, medicalPrescriptionCheck, result.response);
            }
          });
        }
      }
      else
        this.openCheckPrescriptionSolutionModal(prescription, indexPrescriptionCheck, medicalPrescriptionCheck);
    }
    else {
      const dialogRef = this.dialog.open(MedicatedSolutionSchedulingModalComponent, {
        data: {
          observationScheduling: this.observationScheduling,
          cycleTime: this.cycleTime,
          startDateCycle: this.startDateCycle,
          prescriptionItem: prescription,
        },
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result && result.prescription) {
          let index = this.listPrescriptionSolution.findIndex(x => x.prescriptionSolution.idPrescriptionSolution == result.prescription.prescriptionSolution.idPrescriptionSolution)
          if (index != null) {
            this.listPrescriptionSolution[index] = result.prescription;
            this.attPrescription.emit({ listPrescriptionSolution: this.listPrescriptionSolution });
          }
        }
      });
    }
  }

  openCheckPrescriptionSolutionModal(prescription: PrescriptionSolutionStruct, indexPrescriptionCheck: number, selectedPrescriptionCheck: PrescriptionSolutionCheckStruct, verifyPermissionResponse = null) {
    const dialogRef = this.dialog.open(PrescriptionModalComponent, {
      data: {
        prescription: prescription,
        selectedPrescriptionCheck: selectedPrescriptionCheck,
        patientName: this.patientName,
        birthDate: this.birthDate,
        actions: true,
        idEpisode: this.idEpisode,
        isMedicatedSolution: true,
        allergiesToSave: this.allergiesToSave,
        listMedicine: this.listMedicine,
        useScheduling: true,
        verifyPermissionResponse: verifyPermissionResponse,
        listPrescriptionObservationOnBed: this.listPrescriptionObservationOnBed,
        listPresentation: this.listMedicinePresentationType,
        listDilution: this.listDilution,
        listMeasurementUnit: this.listMeasurementUnit,
        listAdministrationType: this.listMedicineAdministrationType,
        listDoseToAdministered: this.listDoseToAdministered,
        listDilutionUnit: this.listDilutionUnit,
        listFrequency: this.listFrequency,
        listSubFrequency: this.listSubFrequency,
        listTreatmentPeriod: this.listTreatmentPeriod,
        listUsage: this.listUsage,
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.checkPrescription.emit(true);
        result.prescriptionSolutionCheckStruct.prescriptionSolutionCheck.idPrescriptionSolution = prescription.prescriptionSolution.idPrescriptionSolution;
        let indexCheck = this.listPrescriptionSolutionCheckStruct.findIndex(l => l.prescriptionSolutionCheck.idPrescriptionSolution == result.prescriptionSolutionCheckStruct.prescriptionSolutionCheck.idPrescriptionSolution);
        if (indexCheck >= 0)
          this.listPrescriptionSolutionCheckStruct[indexCheck] = result.prescriptionSolutionCheckStruct;
        else
          this.listPrescriptionSolutionCheckStruct.push(result.prescriptionSolutionCheckStruct);

        let indexPrescription = this.listPrescriptionSolution.findIndex(x => x.prescriptionSolution.idPrescriptionSolution == prescription.prescriptionSolution.idPrescriptionSolution)
        if (indexPrescription >= 0) {
          if (!selectedPrescriptionCheck)
            selectedPrescriptionCheck = new PrescriptionSolutionCheckStruct();

          selectedPrescriptionCheck.prescriptionSolutionCheck.idStatusScheduling = result.prescriptionSolutionCheckStruct.prescriptionSolutionCheck.idStatusScheduling;
          selectedPrescriptionCheck.prescriptionSolutionCheck.reasonSuspension = result.prescriptionSolutionCheckStruct.prescriptionSolutionCheck.reasonSuspension;
          prescription.listSolutionCheck[indexPrescriptionCheck] = selectedPrescriptionCheck;
          this.listPrescriptionSolution[indexPrescription] = prescription;
        }
      }
    });
  }

  openProcedureSchedulingModal(prescription: MedicalProcedureStruct, date: string, hour: number) {
    if (this.isChecking) {

      if (!prescription.listMedicalProcedureCheck || prescription.listMedicalProcedureCheck.length == 0) {
        this.alertService.show('Alerta', "Não é possível realizar nenhuma interação, pois este item ainda não foi aprazado. Procure o ENFERMEIRO responsável.", AlertType.warning);
        return;
      }

      let [day, month, year] = date.split('/').map(Number);
      let dateStatus = new Date(year, (month - 1), day);
      let indexProcedureCheck = prescription.listMedicalProcedureCheck.findIndex(x => {
        let formatDate = new Date(x.datetimeCheckEstimative);
        return formatDate.getFullYear() == dateStatus.getFullYear()
          && formatDate.getMonth() == dateStatus.getMonth()
          && formatDate.getDate() == dateStatus.getDate()
          && formatDate.getHours() == hour
      });

      if (indexProcedureCheck == null || indexProcedureCheck == undefined) {
        this.alertService.show('Alerta', "Aprazamento não encontrado", AlertType.warning);
      }

      let medicalProcedureCheck = prescription.listMedicalProcedureCheck[indexProcedureCheck];

      if (prescription.listMedicalProcedureCheck.some(prescription => prescription.idStatusScheduling === StatusSchedulingEnum.Suspenso
        && prescription.idMedicalProcedureCheck !== medicalProcedureCheck.idMedicalProcedureCheck
        && prescription.datetimeCheckFulfilled == null
        && !prescription.isBeforeActualSchedulingCycle)) {
        return this.alertService.show('Erro', "Existe uma checagem suspensa para esta prescrição. Salve a conduta para fazer uma nova checagem.", AlertType.error);
      }
      else if (prescription.listMedicalProcedureCheck.some(prescription => prescription.idStatusScheduling === StatusSchedulingEnum.Concluido
        && prescription.idMedicalProcedureCheck !== medicalProcedureCheck.idMedicalProcedureCheck
        && prescription.datetimeCheckFulfilled == null
        && !prescription.isBeforeActualSchedulingCycle)) {
        return this.alertService.show('Erro', "Existe uma checagem concluida para esta prescrição. Salve a conduta para fazer uma nova checagem.", AlertType.error);
      }

      if (medicalProcedureCheck.idStatusScheduling === StatusSchedulingEnum.Aprazado)
        return this.alertService.show('Erro', "Existe uma checagem anterior à ser feita.", AlertType.error);

      if (medicalProcedureCheck.idStatusScheduling === StatusSchedulingEnum.Atrasado) {
        let listRole = this.utilService.getRoles();
        let isMaster = this.utilService.getToken().isMaster;
        if (!listRole.some(x => x.idRole === UserRoleEnum.checar_atrasado_com_restrição) && !isMaster)
          return this.alertService.show('Erro!', "Usuário sem permissão para checar prescrição atrasada.", AlertType.error);
        else {
          const dialogRef = this.dialog.open(CheckRestrictedOverdueMedicationModalComponent, {
          });
          dialogRef.afterClosed().subscribe(result => {
            if (result && result.confirm && result.response) {
              this.openCheckProcedureModal(prescription, indexProcedureCheck, medicalProcedureCheck, result.response);
            }
          });
        }
      }
      else
        this.openCheckProcedureModal(prescription, indexProcedureCheck, medicalProcedureCheck);
    }
    else {
      const dialogRef = this.dialog.open(ProcedureSchedulingModalComponent, {
        data: {
          observationScheduling: this.observationScheduling,
          cycleTime: this.cycleTime,
          startDateCycle: this.startDateCycle,
          prescriptionItem: prescription,
        },
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result && result.prescription) {
          let index = this.listMedicalProcedureStruct.findIndex(x => x.idMedicalProcedure == result.prescription.idMedicalProcedure)
          if (index != null) {
            this.listMedicalProcedureStruct[index] = result.prescription;
            this.attPrescription.emit({ listMedicalProcedureStruct: this.listMedicalProcedureStruct });
          }
        }
      });
    }
  }

  openCheckProcedureModal(prescription, indexProcedureCheck, medicalProcedureCheck, verifyPermissionResponse = null) {
    const dialogRef = this.dialog.open(MedicalProcedureModalComponent, {
      data: {
        procedure: prescription,
        patientName: this.patientName,
        birthDate: this.birthDate,
        idMedicalProcedure: prescription.idMedicalProcedure,
        actions: true,
        idEpisode: this.idEpisode,
        selectedMedicalProcedureCheck: medicalProcedureCheck,
        useScheduling: true,
        verifyPermissionResponse: verifyPermissionResponse
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.checkProcedure.emit(true);
        let index = this.listCheckedProcedure.findIndex(l => l.idMedicalProcedure == result.medicalProcedureCheckRequest.idMedicalProcedure);
        if (index >= 0)
          this.listCheckedProcedure[index] = result.medicalProcedureCheckRequest
        else
          this.listCheckedProcedure.push(result.medicalProcedureCheckRequest);
        if (result.idProcedureSigtap)
          this.procedureSigtapSelected.emit(result.idProcedureSigtap);


        let indexProcedure = this.listMedicalProcedureStruct.findIndex(x => x.idMedicalProcedure == prescription.idMedicalProcedure)
        if (indexProcedure >= 0) {
          if (!medicalProcedureCheck)
            medicalProcedureCheck = new MedicalProcedureCheckStruct();
          medicalProcedureCheck.idStatusScheduling = result.medicalProcedureCheckRequest.idStatusScheduling;
          medicalProcedureCheck.reasonSuspension = result.medicalProcedureCheckRequest.reasonSuspension;
          prescription.listMedicalProcedureCheck[indexProcedureCheck] = medicalProcedureCheck;
          this.listMedicalProcedureStruct[indexProcedure] = prescription;
        }
      }
    });
  }

  openSadtSchedulingModal(prescription: SadtGroupStruct) {
    const dialogRef = this.dialog.open(SadtSchedulingModalComponent, {
      data: {
        observationScheduling: this.observationScheduling,
        cycleTime: this.cycleTime,
        startDateCycle: this.startDateCycle,
        prescriptionItem: prescription,
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.prescription) {
        let index = this.listSadtGroup.findIndex(x => x.idSadtGroup == result.prescription.idSadtGroup)
        if (index != null) {
          this.listSadtGroup[index] = result.prescription;
          this.attPrescription.emit({ listSadtGroup: this.listSadtGroup });
        }
      }
    });
  }

  getStatusScheduling() {
    this.medicalRecordLookupService.getStatusScheduling().subscribe({
      next: (response) => {
        this.isLoading = false;
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }

        if (response.listStatusScheduling && response.listStatusScheduling.length > 0) {
          this.listStatusScheduling = response.listStatusScheduling;
        }
      },
      error: (error) => {
        this.isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  getReasonSuspensionByDateTime(item: any, date: string, hour: string, isProcedure: boolean): string {
    if (this.isChecking) {
      const formattedDate = date.split('/').reverse().join('-');
      const formattedHour = String(hour).padStart(2, '0');
      const datetimeToCompare = `${formattedDate}T${formattedHour}`;
      if (!isProcedure) {
        const prescriptionCheck = item.listPrescriptionMedicineCheck?.find((check: any) => {
          if (check.datetimeCheckEstimative) {
            const checkHour = check.datetimeCheckEstimative.substring(0, 13);
            return checkHour === datetimeToCompare;
          }
        });

        return prescriptionCheck?.reasonSuspension || '';
      }
      else {
        const prescriptionCheck = item.listMedicalProcedureCheck?.find((check: any) => {
          if (check.datetimeCheckEstimative) {
            const checkHour = check.datetimeCheckEstimative.substring(0, 13);
            return checkHour === datetimeToCompare;
          }
        });

        return prescriptionCheck?.reasonSuspension || '';
      }
    }
  }

  isToDisplayLatePendingPrescriptionsCheckButton(item: PrescriptionMedicineStruct): boolean {
    return this.isChecking && (!item.listPrescriptionMedicineCheck || item.listPrescriptionMedicineCheck.some(c => c.isBeforeActualSchedulingCycle && !c.prescriptionMedicineCheck.datetimeCheckFulfilled));
  }

  isToDisplayLatePendingSolutionCheckButton(item: PrescriptionSolutionStruct): boolean {
    return this.isChecking && (!item.listSolutionCheck || item.listSolutionCheck.some(c => c.isBeforeActualSchedulingCycle && !c.prescriptionSolutionCheck.datetimeCheckFulfilled));
  }

  isToDisplayLatePendingProcedureCheckButton(item: MedicalProcedureStruct): boolean {
    return this.isChecking && (!item.listMedicalProcedureCheck || item.listMedicalProcedureCheck.some(c => c.isBeforeActualSchedulingCycle && !c.datetimeCheckFulfilled));
  }

  openLatePendingPrescriptionChecksModal(prescriptionMedicineStruct: PrescriptionMedicineStruct) {
    if (!this.isChecking)
      return;

    const filteredChecks = [...prescriptionMedicineStruct.listPrescriptionMedicineCheck.filter(c => c.isBeforeActualSchedulingCycle && !c.prescriptionMedicineCheck.datetimeCheckFulfilled)];
    const prescriptionMedicineStructStructToPassToModal = { ...prescriptionMedicineStruct };
    prescriptionMedicineStructStructToPassToModal.listPrescriptionMedicineCheck = filteredChecks.map(c => ({ ...c }));

    const dialogRef = this.dialog.open(LatePendingChecksModalComponent, {
      data: {
        prescriptionMedicineStruct: prescriptionMedicineStructStructToPassToModal,
        patientName: this.patientName,
        birthDate: this.birthDate,
        idEpisode: this.idEpisode,
        allergiesToSave: this.allergiesToSave,
        listMedicine: this.listMedicine,
      },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.updateChecksOnItemFromListMedicalPrescriptionStruct(result.prescriptionMedicineStruct);

        let updatedChecks: PrescriptionMedicineCheckStruct[] = result.listPrescriptionMedicineCheckStruct;
        if (updatedChecks) {
          updatedChecks.forEach(newCheck => {
            const index = this.listPrescriptionMedicineCheckStruct.findIndex(l => l.prescriptionMedicineCheck.idPrescriptionMedicineCheck === newCheck.prescriptionMedicineCheck.idPrescriptionMedicineCheck && l.prescriptionMedicineCheck.idPrescriptionMedicine === newCheck.prescriptionMedicineCheck.idPrescriptionMedicine);
            if (index >= 0) {
              this.listPrescriptionMedicineCheckStruct[index] = newCheck;
            } else {
              this.listPrescriptionMedicineCheckStruct.push(newCheck);
            }
          });
        }

        this.checkPrescription.emit(true);
      }
    });
  }

  updateChecksOnItemFromListMedicalPrescriptionStruct(updatedStruct: PrescriptionMedicineStruct): void {
    if (updatedStruct?.listPrescriptionMedicineCheck && updatedStruct.listPrescriptionMedicineCheck.length > 0) {
      const index = this.listPrescriptionMedicine.findIndex(x => x.prescriptionMedicine.idPrescriptionMedicine === updatedStruct.prescriptionMedicine.idPrescriptionMedicine);
      if (index >= 0) {
        const existingChecks = this.listPrescriptionMedicine[index].listPrescriptionMedicineCheck;

        updatedStruct.listPrescriptionMedicineCheck.forEach(updatedCheck => {
          const existingCheckIndex = existingChecks.findIndex(check => check.prescriptionMedicineCheck.idPrescriptionMedicineCheck === updatedCheck.prescriptionMedicineCheck.idPrescriptionMedicineCheck);

          if (existingCheckIndex >= 0)
            existingChecks[existingCheckIndex] = updatedCheck;

        });

        this.listPrescriptionMedicine[index].listPrescriptionMedicineCheck = existingChecks;
      }
    }
  }

  openLatePendingSolutionChecksModal(prescriptionSolutionStruct: PrescriptionSolutionStruct) {
    if (!this.isChecking)
      return;

    const filteredChecks = [...prescriptionSolutionStruct.listSolutionCheck.filter(c => c.isBeforeActualSchedulingCycle && !c.prescriptionSolutionCheck.datetimeCheckFulfilled)];
    const medicatedSolutionStructToPassToModal = {
      ...prescriptionSolutionStruct
    };

    medicatedSolutionStructToPassToModal.listSolutionCheck = filteredChecks.map(c => ({ ...c }));

    const dialogRef = this.dialog.open(LatePendingChecksModalComponent, {
      data: {
        prescriptionSolutionStruct: medicatedSolutionStructToPassToModal,
        patientName: this.patientName,
        birthDate: this.birthDate,
        idEpisode: this.idEpisode,
        allergiesToSave: this.allergiesToSave,
        listMedicine: this.listMedicine,
      },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.updateChecksOnItemFromListMedicalSolutionStruct(result.prescriptionSolutionStruct);

        let updatedChecks: PrescriptionSolutionCheckStruct[] = result.listPrescriptionSolutionCheckStruct;
        if (updatedChecks) {
          updatedChecks.forEach(newCheck => {
            const index = this.listPrescriptionSolutionCheckStruct.findIndex(l => l.prescriptionSolutionCheck.idPrescriptionSolutionCheck === newCheck.prescriptionSolutionCheck.idPrescriptionSolutionCheck && l.prescriptionSolutionCheck.idPrescriptionSolution === newCheck.prescriptionSolutionCheck.idPrescriptionSolution);
            if (index >= 0) {
              this.listPrescriptionSolutionCheckStruct[index] = newCheck;
            } else {
              this.listPrescriptionSolutionCheckStruct.push(newCheck);
            }
          });
        }
        this.checkPrescription.emit(true);
      }
    });
  }

  updateChecksOnItemFromListMedicalSolutionStruct(updatedStruct: PrescriptionSolutionStruct): void {
    if (updatedStruct?.listSolutionCheck && updatedStruct.listSolutionCheck.length > 0) {
      const index = this.listPrescriptionSolution.findIndex(x => x.prescriptionSolution.idPrescriptionSolution === updatedStruct.prescriptionSolution.idPrescriptionSolution);

      if (index >= 0) {
        const existingChecks = this.listPrescriptionSolution[index].listSolutionCheck;

        updatedStruct.listSolutionCheck.forEach(updatedCheck => {
          const existingCheckIndex = existingChecks.findIndex(check => check.prescriptionSolutionCheck.idPrescriptionSolutionCheck === updatedCheck.prescriptionSolutionCheck.idPrescriptionSolutionCheck);
          if (existingCheckIndex >= 0)
            existingChecks[existingCheckIndex] = updatedCheck;
        });

        this.listPrescriptionSolution[index].listSolutionCheck = existingChecks;
      }
    }
  }

  openLatePendingProcedureChecksModal(medicalProcedureStruct: MedicalProcedureStruct) {
    if (!this.isChecking)
      return;

    const filteredChecks = [...medicalProcedureStruct.listMedicalProcedureCheck.filter(c => c.isBeforeActualSchedulingCycle && !c.datetimeCheckFulfilled)];
    const medicalProcedureStructToPassToModal = {
      ...medicalProcedureStruct
    };

    medicalProcedureStructToPassToModal.listMedicalProcedureCheck = filteredChecks.map(c => ({ ...c }));

    const dialogRef = this.dialog.open(LatePendingChecksModalComponent, {
      data: {
        medicalProcedureStruct: medicalProcedureStructToPassToModal,
        patientName: this.patientName,
        birthDate: this.birthDate,
        idEpisode: this.idEpisode,
      },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.updateChecksOnItemFromListMedicalProcedureStruct(result.medicalProcedureStruct);
        this.updateItemInListCheckedProcedure(result.listCheckedProcedure);
        this.checkProcedure.emit(true);

        if (medicalProcedureStruct.idProcedureSigtap)
          this.procedureSigtapSelected.emit(medicalProcedureStruct.idProcedureSigtap);
      }
    });
  }

  updateChecksOnItemFromListMedicalProcedureStruct(updatedStruct: MedicalProcedureStruct): void {
    if (updatedStruct?.listMedicalProcedureCheck && updatedStruct.listMedicalProcedureCheck.length > 0) {
      const index = this.listMedicalProcedureStruct.findIndex(x => x.idMedicalProcedure === updatedStruct.idMedicalProcedure);

      if (index >= 0) {
        const existingChecks = this.listMedicalProcedureStruct[index].listMedicalProcedureCheck;

        updatedStruct.listMedicalProcedureCheck.forEach(updatedCheck => {
          const existingCheckIndex = existingChecks.findIndex(check => check.idMedicalProcedureCheck === updatedCheck.idMedicalProcedureCheck);

          if (existingCheckIndex >= 0)
            existingChecks[existingCheckIndex] = updatedCheck;

        });

        this.listMedicalProcedureStruct[index].listMedicalProcedureCheck = existingChecks;
      }
    }
  }

  updateItemInListCheckedProcedure(updatedChecks: MedicalProcedureCheckRequest[]): void {
    if (updatedChecks) {
      updatedChecks.forEach(newCheck => {
        const index = this.listCheckedProcedure.findIndex(l => l.idMedicalProcedure === newCheck.idMedicalProcedure);
        if (index >= 0) {
          this.listCheckedProcedure[index] = newCheck;
        } else {
          this.listCheckedProcedure.push(newCheck);
        }
      });
    }
  }

  populateLocationSelect() {
    this.locationService.getLocationsToRelease(this.idSector).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }

        this.listLocation = response.listLocation;
      },
      error: (error) => {
        console.log(error);
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  openReleasePrescriptionModal(prescription: any) {
    if (this.isLoadingRelease) return;
    this.isLoadingRelease = true;
    const dialogRef = this.dialog.open(ReleasePrescriptionModalComponent, {
      data: {
        prescription: prescription,
        listPrescription: null,
        episode: {
          idEpisode: this.idEpisode,
          patientName: this.patientName,
          birthDate: this.birthDate
        },
        listLocation: this.listLocation,
        isObservation: true,
        idSector: this.idSector,
      },
    });

    dialogRef.afterClosed().subscribe({
      next: (result) => {
        this.isLoadingRelease = false;
        if (result && result.checkMedicine) {
          if (result.newStatus) {
            prescription.prescriptionMedicine.idPrescriptionStatus = result.newStatus;
            prescription.idPrescriptionStatus = result.newStatus;
          } else {
            prescription.prescriptionMedicine.idPrescriptionStatus = this.prescriptionStatusEnum.Liberado;
            prescription.idPrescriptionStatus = this.prescriptionStatusEnum.Liberado;
          }
          this.releasePrescription.emit(true);
        }
      },
      error: (error) => {
        this.isLoadingRelease = false;
        console.log(error);
      }
    });
  }

  openReleasePrescriptionSolutionModal(solution: any) {
    if (this.isLoadingRelease) return;
    this.isLoadingRelease = true;
    const dialogRef = this.dialog.open(PrescriptionSolutionModalComponent, {
      data: {
        solution: solution,
        listSolution: null,
        episode: {
          idEpisode: this.idEpisode,
          patientName: this.patientName,
          birthDate: this.birthDate
        },
        listLocation: this.listLocation,
        isObservation: true,
        idSector: this.idSector,
      },
    });

    dialogRef.afterClosed().subscribe({
      next: (result) => {
        this.isLoadingRelease = false;
        if (result && result.checkMedicine) {
          solution.idPrescriptionStatus = this.prescriptionStatusEnum.Liberado;
          solution.idSolutionStatus = this.prescriptionStatusEnum.Liberado;
          this.releasePrescription.emit(true);
        } else if (result && result.notDispensedAll) {
          solution.idPrescriptionStatus = this.prescriptionStatusEnum.NaoDispensado;
          solution.idSolutionStatus = this.prescriptionStatusEnum.NaoDispensado;
          this.releasePrescription.emit(true);
        }
      },
      error: (error) => {
        this.isLoadingRelease = false;
        console.log(error);
      }
    });
  }
}